function Loading() {
  return (
    <>
      <span className="w-10 h-10 animate-bounce absolute rounded-full bg-slate-300"></span>
    </>
  );
}

export default Loading;